import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { showToast } from "../utils/show_toast"
import { csrfToken } from "../utils/csrf_token"

// Drag-to-reorder within a day and move stops between day sections. Persists
// each affected list, renumbers each list independently, and notifies the map.
export default class extends Controller {
  static values = { reorderUrl: String }
  static targets = ["list"]

  connect() {
    if (!this.reorderUrlValue) return

    this.sortables = this.listTargets.map((list) =>
      Sortable.create(list, {
        group: "trip-itinerary",
        handle: ".sortable-handle",
        animation: 150,
        ghostClass: "opacity-50",
        draggable: "[data-trip-thing-id]",
        onEnd: (event) => this.onEnd(event)
      })
    )

    this.renumber()
    this.dispatchPoints()
  }

  disconnect() {
    (this.sortables || []).forEach((sortable) => sortable.destroy())
  }

  onEnd(event) {
    const lists = new Set([event.from, event.to])

    Promise.all(Array.from(lists).map((list) => this.persist(list)))
      .then(() => {
        this.renumber()
        this.dispatchPoints()
      })
  }

  persist(list) {
    const dayId = list.dataset.tripDayId || null
    const orderedIds = Array.from(list.querySelectorAll("[data-trip-thing-id]"))
      .map((row) => row.dataset.tripThingId)

    return fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken(),
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ trip_day_id: dayId, ordered_ids: orderedIds })
    }).then((response) => {
      if (!response.ok) throw new Error("reorder failed")
    }).catch(() => {
      showToast("Couldn't save the new order", "error")
    })
  }

  renumber() {
    this.listTargets.forEach((list) => {
      let counter = 1
      list.querySelectorAll("[data-position-number]").forEach((badge) => {
        badge.textContent = String(counter)
        counter += 1
      })
    })
  }

  dispatchPoints() {
    const points = []

    this.listTargets.forEach((list) => {
      list.querySelectorAll("[data-trip-thing-id]").forEach((row) => {
        const lat = parseFloat(row.dataset.lat)
        const lng = parseFloat(row.dataset.lng)
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          points.push({ lat, lng, name: row.dataset.name })
        }
      })
    })

    this.dispatch("changed", { target: window, detail: { points } })
  }
}
